export const QUERY_CACHE_DEFAULT_EXPIRATION_MS = 1000 * 60 * 5;
export const QUERY_CACHE_SHORT_EXPIRATION_MS = 1000 * 60 * 3;
export const QUERY_CACHE_LONG_EXPIRATION_MS = 1000 * 60 * 10;
export const QUERY_CACHE_EXTRA_LONG_EXPIRATION_MS = 1000 * 60 * 30;
export const QUERY_REVALIDATE_ON_FOCUS_THRESHOLD_MS = 1000 * 60;

export const SWITCHES_QUERY_KEY = "getFeatureSwitches";
export const MAINTENANCE_STATUS_QUERY_KEY = "getMaintenanceStatus";

export const USER_QUERY_KEY = "getUserKey";
export const USERS_QUERY_KEY = "getUsersKey";
export const COLLABORATIVE_TOKENS_QUERY_KEY = "getCollaborativeTokensKey";
export const TIMEZONE_QUERY_KEY = "getTimezones";
export const ATTRIBUTES_QUERY_KEY = "getAllAttributes";
export const PLACES_AUTOCOMPLETE_QUERY_KEY = "getPlaceAutocomplete";
export const CURRENCIES_QUERY_KEY = "getOrganizationCurrencies";

// Emails
export const EMAIL_QUERY_KEY = "getEmailKey";
export const REMOVE_EMAIL_MUTATION_KEY = "removeEmailMutationKey";
export const REMOVE_THREAD_MUTATION_KEY = "removeThreadMutationKey";
export const SYNC_EMAIL_MUTATION_KEY = "syncEmailMutationKey";
export const THREAD_QUERY_KEY = "getThreadKey";
export const THREAD_ATTACHMENTS_QUERY_KEY = "getThreadAttachmentsKey";
export const THREAD_AI_CONTEXT_QUERY_KEY = "getThreadAIContextKey";
export const UPDATE_THREAD_NOTE_MUTATION_KEY = "updateThreadNoteKey";

// Meetings
export const MEETING_QUERY_KEY = "getMeetingKey";
export const SYNC_MEETING_MUTATION_KEY = "syncMeetingKey";
export const UPDATE_MEETING_MUTATION_KEY = "updateMeetingKey";
export const REMOVE_MEETING_MUTATION_KEY = "removeMeetingKey";
export const MEETING_OBJECTS_QUERY_KEY = "getMeetingObjectsKey";
export const ADD_MEETING_ATTENDEE_MUTATION_KEY = "addMeetingAttendeeKey";
export const REMOVE_MEETING_ATTENDEE_MUTATION_KEY = "removeMeetingAttendeeKey";
export const CREATE_MEETING_OBJECT_MUTATION_KEY = "createMeetingObjectKey";

// Relations
export const OBJECT_TAGS_QUERY_KEY = "getObjectTagsKey";
export const CREATE_OBJECT_TAG_MUTATION_KEY = "createObjectTagMutationKey";
export const CREATE_BATCH_OBJECT_TAGS_MUTATION_KEY = "createBatchObjectTagsMutationKey";
export const REMOVE_OBJECT_TAG_MUTATION_KEY = "removeObjectTagMutationKey";
export const TAGGING_OPTIONS_QUERY_KEY = "getTaggingOptionsKey";
export const DISCUSSED_TOPICS_QUERY_KEY = "getDiscussedTopicsKey";
export const SUGGESTED_TAGGING_OPTIONS_QUERY_KEY = "getSuggestedTaggingOptionsKey";

// Sourcing
export const SOURCING_SETTINGS_QUERY_KEY = "getSourcingSettingsKey";
export const SOURCING_THEMES_QUERY_KEY = "getSourcingThemesKey";
export const SOURCING_THEMES_TREE_QUERY_KEY = "getSourcingThemesTreeKey";

// Notes
export const NOTE_QUERY_KEY = "getNoteKey";
export const BOUND_NOTE_QUERY_KEY = "getBoundNoteKey";
export const BOUND_NOTES_QUERY_KEY = "getBoundNotesKey";
export const CREATE_NOTE_MUTATION_KEY = "createNoteKey";
export const UPDATE_NOTE_MUTATION_KEY = "updateNoteKey";

// Deals
export const DEALS_QUERY_KEY = "getDealsKey";
export const DEAL_SOURCE_TYPES_QUERY_KEY = "getDealSourceTypesKey";
export const DEAL_STAGES_QUERY_KEY = "getDealStagesKey";
export const CREATE_DEAL_MUTATION_KEY = "createDealKey";

// Companies
export const COMPANY_QUERY_KEY = "getCompanyKey";
export const COMPANIES_QUERY_KEY = "getCompaniesKey";
export const COMPANY_SUGGESTIONS_QUERY_KEY = "getCompanySuggestionsKey";
export const COMPANY_STAGES_QUERY_KEY = "getCompanyStagesKey";
export const COMPANY_PRIORITIES_QUERY_KEY = "getCompanyPrioritiesKey";
export const COMPANY_TYPES_QUERY_KEY = "getCompanyTypesKey";
export const CREATE_COMPANY_MUTATION_KEY = "createCompanyKey";
export const UPDATE_COMPANY_MUTATION_KEY = "updateCompanyKey";
export const CREATE_COMPANY_FROM_EXTERNAL_MUTATION_KEY = "createCompanyFromExternalKey";
export const ADD_ALTERNATIVE_DOMAIN_MUTATION_KEY = "addAlternativeDomainKey";
export const UPDATE_ALTERNATIVE_DOMAIN_MUTATION_KEY = "updateAlternativeDomainKey";
export const DELETE_ALTERNATIVE_DOMAIN_MUTATION_KEY = "deleteAlternativeDomainKey";
export const FILTER_ALL_COMPANIES_QUERY_KEY = "getAllCompaniesFilter";
export const FIND_COMPANY_BY_WEBSITE_QUERY_KEY = "findCompanyByWebsiteKey";

// Feedback
export const FEEDBACK_OPTIONS_QUERY_KEY = "getFeedbackOptionsKey";
export const CREATE_FEEDBACK_MUTATION_KEY = "createFeedbackKey";
export const UPDATE_FEEDBACK_MUTATION_KEY = "updateFeedbackKey";

// People
export const ALL_PEOPLE_OPTIONS_QUERY_KEY = "allPeopleOptionsKey";
export const SEARCHED_PEOPLE_QUERY_KEY = "searchPeopleKey";
